<div class="flex flex-col gap-1">
  <label class="text-gray-500 text-sm font-light leading-6">
    {{label}}<span *ngIf="starIcon" class="text-orange-600">{{starIcon}}</span>
  </label>
  <div class="relative w-full">
    <select 
      [formControl]="control"
      class="w-full h-10 px-4 py-2 rounded-md bg-white border border-[#5f6d7e] font-light text-[14px] leading-[24px] appearance-none cursor-pointer hover:border-[#5f6d7e] focus:outline-none focus:border-[#5f6d7e] focus:ring-0 pr-10">
      <option [ngValue]="null" disabled>{{ placeholder }}</option>
      <option *ngFor="let option of options" [value]="option.id">
        {{ option.name }}
      </option>
    </select>
    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-500">
      <fa-icon [icon]="faChevronDown" class="text-sm"></fa-icon>
    </div>
  </div>
</div>
